module.exports = __webpack_public_path__ + "img/page-more.d479d4b0.png";